// extracted by mini-css-extract-plugin
module.exports = {"indicator":"ec63vK6OaDKpQ2_Im0iBQ","active":"_1Zw4_eZnLliSY0UjoOWrs8","medium":"_1P1255dA14b3RxSvbY_7wU","large":"_1B0Ge5xqWe5-ICWfqLF94_"};